import { gql } from '@apollo/client';

export const getCompanyPositiveFeedbackComponents = gql`
  query getCompanyPositiveFeedbackComponents {
    company {
      id
      positiveFeedbackComponents
    }
  }
`;
